/**
 * @generated SignedSource<<2cb604d13729a20e544dae70e71484f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type MarketingEmailStatus = "DRAFT" | "PARTIALLY_SENT" | "SENDING" | "SENT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MarketingEmailList_query$data = {
  readonly marketingEmails: ReadonlyArray<{
    readonly archivedAt: any | null | undefined;
    readonly createdAt: any;
    readonly emailTemplate: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly id: string;
    readonly mailingList: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly marketingEmailIdentifier: string;
    readonly name: string;
    readonly recipientCount: number;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly sentAt: any | null | undefined;
    readonly status: MarketingEmailStatus;
  }>;
  readonly " $fragmentType": "MarketingEmailList_query";
};
export type MarketingEmailList_query$key = {
  readonly " $data"?: MarketingEmailList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"MarketingEmailList_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MarketingEmailList_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketingEmail",
      "kind": "LinkedField",
      "name": "marketingEmails",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "marketingEmailIdentifier",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "senderName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "senderEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recipientCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "archivedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MailingList",
          "kind": "LinkedField",
          "name": "mailingList",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailTemplate",
          "kind": "LinkedField",
          "name": "emailTemplate",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "9c41dd20ea86a7531643bd158cbef63b";

export default node;
